import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "component-variable-value-v2 component-variable-value--enum" };
import Strings from "src/shared/Strings";
import DropdownSelectorInput from "src/shared/v-components/ui/form/DropdownSelectorInput.vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EnumComponentVariableBuiltValue',
    props: {
        modelValue: {},
        allowedValues: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isString = (value) => {
            return typeof value === "string";
        };
        const valueProxy = computed({
            get() {
                return isString(props.modelValue) ? props.modelValue : "";
            },
            set(value) {
                emit("update:modelValue", value);
            },
        });
        const options = computed(() => {
            return props.allowedValues.map((value) => {
                return {
                    displayName: Strings.capitalize(value),
                    value: value,
                };
            });
        });
        const selectedOption = computed(() => {
            return options.value.find((option) => option.value === props.modelValue);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(DropdownSelectorInput, {
                    disabled: true,
                    modelValue: valueProxy.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((valueProxy).value = $event)),
                    options: options.value
                }, null, 8 /* PROPS */, ["modelValue", "options"])
            ]));
        };
    }
});
